import * as Yup from "yup";

export const dataModel = {
  dateInit: "",
  dateEnd: "",
  itemCode: "",
  batch: "",
  locationStorageCode: "",
};

export const validationDataModel = Yup.object().shape({
  dateInit: Yup.date().optional("forms.validations.required"),
  dateEnd: Yup.date().optional("forms.validations.required"),
  itemCode: Yup.string().optional(""),
  batch: Yup.string().optional(""),
  locationStorageCode: Yup.string().optional(""),
});

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
